import React from 'react'
import NdsThemeProvider from '@ntuctech/devex-tangram/Theme/NdsThemeProvider'
import Head from '../../components/Union/Head'
import Loader from '../../components/Union/Loader'
import LoginScreen from '../../components/Union/LoginScreen/LoginScreen'
import useAuth from '../../components/Union/hooks/useAuth'
import { Container } from '../../components/Union/styled'

const FpmPage = () => {
  const {
    isNewSession,
    isLoading,
    redirectToProfile,
    saveCredentials,
  } = useAuth()

  return (
    <>
      <Head />
      <NdsThemeProvider>
        <Loader isLoading={isLoading} />
        <Container data-hidden={isLoading} data-testid="union-page">
          <LoginScreen
            isNewSession={isNewSession}
            redirectToProfile={redirectToProfile}
            saveCredentials={saveCredentials}
          />
        </Container>
      </NdsThemeProvider>
    </>
  )
}

export default FpmPage
